import { ApiClient } from "@ucl/library";
import { SanctionsMatchReadDTO } from "../types/SanctionsMatchReadDTO";

class SanctionsApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  getSanctionsMatch = async (sanctionsMatchId: string) => {
    return this._apiClient.get<SanctionsMatchReadDTO>(`api/Sanctions/${sanctionsMatchId}`);
  };
}

export default SanctionsApiClient;
